import { apiFetch } from "@/lib/api";

export type Client = {
  id: number;
  first_name: string;
  last_name: string;
  name?: string | null;
  company?: string | null;
  group_name?: string | null;
  partner_id?: number | null;
  country?: string | null;
  email?: string | null;
  mobile?: string | null;
  alternate_phone?: string | null;
  operator_agency_name?: string | null;
  final_client_type?: string | null;
  client_types?: string[] | null;
  referred_from?: string | null;
  language: string;
  notes?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type ClientListItem = {
  id: number;
  first_name: string;
  last_name: string;
  company?: string | null;
  partner_id?: number | null;
  country?: string | null;
  final_client_type?: string | null;
  client_types?: string[] | null;
  email?: string | null;
  mobile?: string | null;
  language: string;
};

export type ClientListResponse = {
  items: ClientListItem[];
  total: number;
};

export const fetchClients = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
  partnerId?: number | null;
}): Promise<ClientListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  if (typeof params.partnerId === "number") query.set("partner_id", String(params.partnerId));
  const payload = await apiFetch<ClientListResponse | null>(`/clients?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getClient = async (id: number): Promise<Client> => {
  return apiFetch<Client>(`/clients/${id}`);
};

export const createClient = async (data: Partial<Client>): Promise<Client> => {
  return apiFetch<Client>("/clients", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createClientImport = async (data: Partial<Client>): Promise<Client> => {
  return apiFetch<Client>("/clients/import", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateClient = async (id: number, data: Partial<Client>): Promise<Client> => {
  return apiFetch<Client>(`/clients/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteClient = async (id: number): Promise<void> => {
  await apiFetch<void>(`/clients/${id}`, { method: "DELETE" });
};

export const deleteAllClients = async (params?: { partnerId?: number | "none" }): Promise<void> => {
  const query = new URLSearchParams();
  if (params && typeof params.partnerId !== "undefined") {
    query.set("partner_id", String(params.partnerId));
  }
  const suffix = query.toString();
  await apiFetch<void>(suffix ? `/clients?${suffix}` : "/clients", { method: "DELETE" });
};
